var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "Polaris-ResourceList"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "Polaris-ResourceList__ItemWrapper"
    }, [_vm._t("item", [_c('polaris-resource-list-item', {
      attrs: {
        "url": item.url,
        "media": item.media,
        "attribute-one": item.attributeOne,
        "attribute-two": item.attributeTwo,
        "attribute-three": item.attributeThree,
        "badges": item.badges,
        "exceptions": item.exceptions,
        "actions": item.actions,
        "persist-actions": item.persistActions
      }
    })], {
      item: item,
      index: index
    })], 2)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a9effaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a9effaa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisResourceList.vue
// module id = 337
// module chunks = 0